import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { TrendConfigurationTypeEnum } from "../../common/enums/TrendConfigurationTypeEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["object-graph-config"],
    chartProperties: (
        groupID: number,
        eLynxObject: IeLynxObject,
        trigger: any
        ) => [
            ...keys.all,
            "chart-properties", {
                groupID,
                eLynxObject,
                trigger
            }
        ],
    configuration: (groupID: number, eLynxObject: IeLynxObject, configurationID: number) => [
        ...keys.all,
        "configuration", {
            groupID,
            configurationID,
            eLynxObject
        }
    ],
    configurationDefaultOptions: (groupID: number, eLynxObject: IeLynxObject, configurationID: number) => [
        ...keys.all,
        "configuration-default-options", {
            groupID,
            configurationID,
            eLynxObject
        }
    ],
    configurationLists: () => [
        ...keys.all,
        "configuration-list"
    ],
    configurationList: (groupID: number, eLynxObject: IeLynxObject | undefined) => [
        ...keys.configurationLists(),
        {
            groupID,
            eLynxObject
        }
    ],
    availableObjects: (
        customerID: number,
        groupID: number,
        includeDescendentGroups: boolean,
        includeDevices: boolean | undefined,
        includeTanks: boolean | undefined,
        includeTankBatteries: boolean,
        includeWells: boolean | undefined,
        offline: boolean
    ) => [
            ...keys.all,
            "availableObjects", {
                customerID,
                groupID,
                includeDescendentGroups,
                includeDevices,
                includeTanks,
                includeTankBatteries,
                includeWells,
                offline
            }
        ],
    availableColumns: (
        groupID: number,
        objects: Array<IeLynxObject>,
        dataType: eLynxObjectTypeEnum
    ) => [
            ...keys.all,
            "availableColumns", {
                groupID,
                objects,
                dataType
            }
    ],
    allConfigurations: (groupID: number, configurationType: TrendConfigurationTypeEnum) => [
        ...keys.all,
        "all-configurations", {
            groupID,
            configurationType
        }
    ],

};

